import justificativaFaltaService from "@/Services/JustificativaFaltaService";
import $handleError from "@/plugins/handleError";

const state = () => ({
  totalPendentes: 0,
});

const mutations = {
  setTotalPendentes(state, total) {
    state.totalPendentes = total;
  },
};

const actions = {
  async carregarPendentes({ commit }) {
    try {
      const total = await justificativaFaltaService.contarPendentes();
      commit("setTotalPendentes", total);
    } catch (error) {
      $handleError(error);
    }
  },
};

const getters = {
  totalPendentes: (state) => state.totalPendentes,
};

const namespaced = true;

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced,
};
